import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { Tooltip, Box, Text } from '@pinchenterprisesnpm/friday-ui'
import { EditIcon as EditIconStyled } from './edit-icon.style'

interface IEditIconProps {
  onEdit?: () => void
  isDisabled?: boolean
  disabledTooltipText?: string
}

export const EditIcon = ({
  onEdit,
  isDisabled,
  disabledTooltipText,
}: IEditIconProps) => {
  if (isDisabled) {
    return (
      <Tooltip text={disabledTooltipText}>
        <EditIconStyled icon={faPen} isDisabled />
      </Tooltip>
    )
  }

  const richTooltipContent = (
    <Box p="sm">
      <Text fontWeight="bold" mb="xs" m={0}>
        Edit Section
      </Text>
      <Text fontSize="small" m={0}>
        Click to modify the details of this section
      </Text>
    </Box>
  )

  return (
    <Tooltip
      theme="light"
      placement="top"
      content={richTooltipContent}
      trigger="mouseenter"
    >
      <div>
        <EditIconStyled icon={faPen} onClick={onEdit} />
      </div>
    </Tooltip>
  )
}
